import { updateDevices } from './devices';
import { hasCameraAndMicrophoneAccess } from '../selectors/devices';
export const mediaAccessDenied = () => (dispatch) => dispatch(openModalDisableCamera());
export const mediaAccessAllowed = () => (dispatch, getState) => {
    dispatch(closeModalDisableCamera());
    // when access enabled we have to check for devices labels and reset cache
    if (!hasCameraAndMicrophoneAccess(getState())) {
        dispatch(updateDevices());
    }
};
export const openModalDisableCamera = () => (dispatch) => {
    dispatch({ type: 'DEVICES/TOGGLE_MODAL_DISABLE_CAMERA', payload: true });
};
export const closeModalDisableCamera = () => (dispatch) => {
    dispatch({
        type: 'DEVICES/TOGGLE_MODAL_DISABLE_CAMERA',
        payload: false,
    });
};
